// import React from "react";
// import './style.scss';
// import { image } from "../../../Assets";

// const Footer = () =>{
//     return(<>
//         <footer>
//             <div className="container main-footer">
//                 <div className="row">
//                     <div className="col-lg-3 col-12 info-sec">                        
//                         <img src={image.logo} alt="" />
//                         <div className="col-lg-12 col-12">
//                             <form action="https://formsubmit.co/contact@fractilestud.io" method="POST" id="contactform">                          
                                
//                                 <label>
//                                     <input type="text" name="email" placeholder="Enter your email for newsletters"/>
//                                 </label>
//                                 <div className="sbt">
//                                 <input type="submit" value="Subscribe" />
//                                 </div>
//                             </form>
//                             {/* <img src={image.footerbg} alt=""  id="footerbg"/> */}
//                         </div>
//                     </div>    
//                     <div className="col-lg-7 col-12 quicklink-wrapper">          
//                         <div className="d-flex">
//                             <div className="quicklink">
//                                 <h5>Home</h5>
//                                 <ul>
//                                     <li>Conversion</li>
//                                     <li>Clients</li>
//                                     <li>Our Solutions</li>
//                                     <li>Case Study</li>
//                                     <li>Testimonials</li>
//                                 </ul>
//                             </div>
//                             <div className="quicklink">
//                                 <h5>About</h5>
//                                 <ul>
//                                     <li>Our Approach</li>
//                                     <li><a href="/team">Our Team</a></li>
//                                 </ul>
//                             </div><div className="quicklink">
//                                 <h5>Industries</h5>
//                                 <ul>
//                                     <li>Education</li>
//                                     <li>Government</li>
//                                     <li>Healthcare</li>
//                                     <li>Transportation</li>
//                                 </ul>
//                             </div>
//                             <div className="quicklink">
//                                 <h5>Services</h5>
//                                 <ul>
//                                     <li>BIM/VDC Services</li>
//                                     <ul className="sublink">
//                                         <li>Visualization</li>
//                                         <li>Modeling</li>
//                                         <li>BIM Management</li>
//                                     </ul>
//                                     <li>Project engineering Services</li>
//                                     <ul className="sublink">
//                                         <li>Shop Drawing Creation</li>
//                                         <li>2D Overlay</li>
//                                         <li>Document Management for RFIs, Submittals & Change Orders </li>
//                                     </ul>
//                                 </ul>
//                             </div>
//                             <div className="quicklink">
//                                 <h5>Resources</h5>
//                                 <ul>
//                                     <li>Blog</li>
//                                     <li>Case Study</li>
//                                     <li>Events</li>
//                                 </ul>
//                             </div>
//                         </div>
//                     </div>  
//                     <div className="col-lg-2 col-12">          
//                         <div className="d-flex tw-flex-col tw-justify-between">
//                             <ul className="socials">
//                                 <li>
//                                     <img src={image.fbicon} alt="" />
//                                 </li>
//                                 <li>
//                                     <img src={image.instaicon} alt="" />
//                                 </li>
//                                 <li>
//                                     <img src={image.xicon} alt="" />
//                                 </li>
//                             </ul>
//                             <div className="d-flex tw-justify-between">
//                                 <span style={{color:'#157438',fontSize:' 12px'}}>Powered By Techxerro</span>
//                                 <span style={{color:'#157438',fontSize:'12px'}}><a href="/privact-policy">Privacy Policy</a></span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </footer>
//     </>)
// }

// export default Footer;

import React from "react";
import "./style.scss";
import { image } from "../../../Assets";

const Footer = () => {
  return (
    <footer>
      <div className="container main-footer">
        <div className="row">
          {/* Info Section */}
          <div className="col-lg-3 col-12 info-sec">
            <img src={image.logo} alt="" />

            <div className="col-lg-12 col-12">
              <form
                action="https://formsubmit.co/contact@fractilestud.io"
                method="POST"
                id="contactform"
                className="tw-mt-6"
              >
                <label>
                  <input
                    type="text"
                    name="email"
                    placeholder="Enter email for newletter"
                  />
                </label>

                <div className="sbt">
                  <input type="submit" value="Subscribe" />
                </div>
              </form>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-xl-7 col-lg-9 col-md-8 col-12 quicklink-wrapper">
            <div className="tw-grid tw-grid-cols-1 md:tw-flex sm:tw-gap-8 tw-gap-4">
              <div className="quicklink">
                <h5>Home</h5>
                <ul>
                  
                  <li><a href={`/#whatwedo`}>What we do</a></li>
                  <li><a href="/#Industries">Clients</a></li>
                  <li><a href="/#conversion">Conversion</a></li>
                  <li><a href="/#whyChooseUs">Why choose us</a></li>
                  {/* <li><a href="/#bookACall">Book a call</a></li> */}
                </ul>
              </div>

              <div className="quicklink">
                <h5>About</h5>
                <ul>
                  <li><a href="/">Our Approach</a></li>
                  <li>
                    <a href="/team">Our Team</a>
                  </li>
                </ul>
              </div>

              <div className="quicklink">
                <h5>Services</h5>
                <ul>
                  <li>BIM/VDC Services</li>
                  <ul className="sublink">
                      <li className="tw-text-[#157438]">Visualization</li>
                      <ul>
                        <li><a href="/visualisation/2D&3D-rendering">2D / 3D Rendering</a></li>
                        <li><a href="/visualisation/3D-Walkthrough-Flythrough">3D Walkthroughs</a></li>
                        <li><a href="/visualisation/4D-Simulations">4D Simulations</a></li>
                      </ul>
                      <li className="tw-text-[#157438]">Modeling</li>
                      <ul>
                        <li><a href="/modeling/2D-to-3D-modeling">2D(CAD/PDF) to Supplemental 3D Modeling</a></li>
                        <li ><a href="/modeling/supplemental-modeling">Supplemental Modeling</a></li>
                        <li><a href="/modeling/point-cloud-to-3D-modeling">Point Cloud to 3D Modeling</a></li>
                      </ul>
                      <li className="tw-text-[#157438]">BIM Management</li>
                      <ul>
                        <li><a href="/BIM-Management/clash-detection-and-coordination">Clash Detection and Coordination</a></li>
                        <li><a href="/BIM-Management/BIM-execution-planning">BIM Execution Planning</a></li>
                     </ul>                    
                  </ul>
                </ul>
              </div>

              <div className="quicklink">
                <h5 className="sm:tw-block tw-hidden">&nbsp;</h5>
                <ul>
                  <li>Project Engineering Services</li>
                  <ul className="sublink">
                      <li><a href="/shop-drawing-creation">Shop Drawing Creation</a></li>
                      <li><a href="/2D-overlay">2D Overlay</a></li>
                      <li>
                        <a href="/RFI-order-date-in-PM-software">
                          Document Management for RFIs, Submittals & Change Orders
                        </a>
                      </li>
                  </ul>
                </ul>
              </div>
            </div>
          </div>

          {/* Social + Footer Bottom */}
          <div className="col-xl-2 col-lg-12 col-md-12 col-12">
            <div className="d-flex tw-flex-col tw-justify-end tw-h-full">
              <ul className="socials">
                <li>
                  <a href="https://www.linkedin.com/company/fractile-studio-llc/posts/?feedView=all" target="_blank"><img src={image.linkedincon} alt="" /></a>
                </li>
              </ul>

              <div className="d-flex tw-flex-col sm:tw-items-end tw-items-center tw-gap-1">
                <span className="tw-text-[#157438] tw-text-[12px]">
                  <a href="/privacy-policy">Privacy Policy</a>
                </span>
                <span className="tw-text-[#157438] tw-text-[12px]">
                  <a href="/terms-and-condition">Terms & Condition</a>
                </span>
                <span className="tw-text-[#157438] tw-text-[12px]">
                  Powered By <a href="https://www.techxerro.com" className="hover:tw-text-[yellow]" target="_blank">Techxerro</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
